<template>
  <div class="animated fadeIn list-of-opi">
    <b-card>
      <div slot="header">Realisasi Iklan Cetak
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="showGeserJadwal"><i class="fa fa-cog"></i>Geser Jadwal</button>
          <button class="btn btn-primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
              <b-row>
                <b-col md="12" xl="10">
                  <b-input-group >
                    <!-- <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Tgl. OPI</span></b-input-group-prepend> -->
                      <b-input-group-prepend><label >Jadwal Tayang</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">s.d</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>  
              <b-row>
                <b-col md="12" xl="10">
                  <b-input-group >
                    <b-input-group-prepend><label>Halaman/Rubrik</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.posisirubrik" ></b-form-input>
                    <b-form-radio-group class="ml-1 mt-2" v-model="tblData.baris" >
                      <b-form-radio value="0">Display & Class.</b-form-radio>
                      <b-form-radio value="1">Baris</b-form-radio>
                      <b-form-radio value="">Semua</b-form-radio>
                    </b-form-radio-group>
                  </b-input-group>
                </b-col>
              </b-row>  
              <b-row>
                <b-col md="6" xl="5">
                    <b-input-group >
                      <b-input-group-prepend><label >Nomor OPI</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.orderno" ></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col md="6"  xl="5">
                    <b-input-group >
                      <b-input-group-prepend><label >Sales Order No.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.mediaorder" ></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>  

        </b-col>
        <b-col lg="6" xl=5>
              <b-input-group >
                <b-input-group-prepend><label>Pemasang</label></b-input-group-prepend>
                <b-form-input v-model="tblData.pemasang" @change="tblData.customer_id=''" placeholder="Perusahaan Biro Iklan/Perorangan"></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-form-input v-model="tblData.Advertiser" placeholder="Advertiser" class="ml-1"></b-form-input>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                <b-form-input v-model="tblData.jiklan" @change="tblData.jiklanid=''" ></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" text="Button" @click="lkuJenisIklanShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Judul</span></b-input-group-prepend>
                <b-form-input v-model="tblData.juduliklan" placeholder="Keterangan iklan"></b-form-input>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Bentuk Bayar</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.jenisbayar" :plain="true" :options="paymentForms"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">Tayang/Muat</span></b-input-group-prepend>
                <!-- <b-input-group-prepend><label >Tayang/Muat</label></b-input-group-prepend> -->
                  <b-form-select v-model="tblData.istayang" :plain="true" :options="YesNoAll"></b-form-select>
                <!-- <b-input-group-prepend><span class="pl-1 pt-2">AE</span></b-input-group-prepend>
                <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesid_id=''" style="width:21% !important;"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                </b-input-group-append> -->
                <b-input-group-append class="ml-2">
                  <b-button variant="success" size="sm" @click="refresh()"><i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button variant="secondary" size="sm" class="ml-1" @click="clearFilter()">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(jiklan)="data">
          {{data.item.jiklan}} <span v-if="data.item.baris==0"> ({{data.item.jwarna}}) </span>
        </template>
        <template v-slot:cell(jadwalmuat)="data">
          {{ data.item.jadwalmuat | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(halaman)="data">
          <b-input-group v-if="(data.item._rowVariant== 'info')">
            <span v-if="data.item.istayang==1"><i class="fa fa-tag "></i> {{ data.item.halaman}}</span>                      
            <span v-if="(data.item.buktiiklan)" class="ml-1 mr-1"> <i class="fa fa-check "></i>Bukti Iklan </span>
            <b-input-group-append>
              <b-button variant="success" class="mr-1" size="sm" @click.stop="showForm=true">
                <i class="fa fa-tag"></i> Muat
              </b-button>
            </b-input-group-append>
            <b-input-group-append v-if="(data.item.istayang==0)">
              <b-button variant="primary" size="sm" @click.stop="showGeserJadwal">
                <i class="fa fa-cog"></i>Geser
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <div v-else>
            <span v-if="data.item.istayang==1" class="ml-1 mr-1"><i class="fa fa-tag "></i> {{ data.item.halaman}}</span>                      
            <span v-if="(data.item.buktiiklan)"> <i class="fa fa-check "></i>Bukti Iklan </span>
          </div>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>        
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true" :lazy="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>   
         <b-modal v-model="lkuJenisIklanShow" size="lg" :hide-footer="true" title="Jenis Iklan" :centered="true" :lazy="true">
            <lku-jenisiklan @click="onSelectLkuJenisIklan" ></lku-jenisiklan>
        </b-modal>  
    <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>

      <b-modal v-model="showForm" header-bg-variant="primary"  title="Form - Realisasi Iklan" size="md" :centered="true" hide-footer>
          <b-input-group>
              <b-input-group-prepend><label style="width: 80px !important;">Order No.</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.orderno" readonly></b-form-input>
              <b-input-group-prepend><span class="p-2">Order Date</span></b-input-group-prepend>
              <b-form-input :value="frmdata.orderdate | moment('DD MMM YYYY')"  disabled></b-form-input>  
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label style="width: 80px !important;">Customer</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.CustName"  readonly></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label style="width: 80px !important;">Judul Iklan</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.juduliklan"  readonly></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label style="width: 80px !important;">Jenis Iklan</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.jiklan"  readonly></b-form-input>
              <b-form-input v-model="frmdata.ukuraniklan"  readonly class="ml-1"></b-form-input>
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label >Jadwal Tayang </label></b-input-group-prepend>
                <b-form-input :value="frmdata.jadwalmuat | ambilNamaHari" readonly class="font-weight-bold mr-1" ></b-form-input>
                <b-form-input :value="frmdata.jadwalmuat | moment('DD MMM YYYY')" readonly class="font-weight-bold" style="width:35% !important;"></b-form-input>
          </b-input-group>
          <b-input-group v-if="(showFormGeser==true)">
            <b-input-group-prepend><label >Jadwal Tayang BARU </label></b-input-group-prepend>
                <b-form-input :value="frmdata.jadwalgeser | ambilNamaHari" readonly class="font-weight-bold mr-1" ></b-form-input>
                    <b-form-input v-model="frmdata.jadwalgeser" type="date" :state="!$v.frmdata.jadwalgeser.$error" style="width:35% !important;"></b-form-input>
          </b-input-group>
          <b-input-group v-if="(showFormGeser==true)">
            <b-input-group-prepend><label >Alasan perubahan Jadwal </label></b-input-group-prepend>
            <b-form-input v-model="frmdata.uraiangeser"  :state="!$v.frmdata.uraiangeser.$error" ></b-form-input>
          </b-input-group>
          <b-input-group v-if="(showFormGeser==false)">
            <b-input-group-prepend><label >Tayang di halaman </label></b-input-group-prepend>
            <b-form-input v-model="frmdata.halaman" :state="!$v.frmdata.halaman.$error" ></b-form-input>
            <b-input-group-prepend><span class="p-2">(page/chanel)</span></b-input-group-prepend>
          </b-input-group>
          <b-input-group v-if="(showFormGeser==false)">
            <b-input-group-prepend><label >Upload Bukti Iklan</label></b-input-group-prepend>
            <b-img :src="frmdata.imgURL" thumbnail fluid alt="Photo Bukti Iklan" v-if="(frmdata.imgURL)" class="mr-2"></b-img>
            <ImgCutter v-on:cutDown="cutDown" label="Choose Image" :isModal="true" :scaleAble="true" >
                <template #open>
                    <button>Choose image</button>
                </template>
            </ImgCutter>              
          </b-input-group>

              <b-row class="justify-content-center mt-1" > 
                  <b-button v-if="(showFormGeser==true)" variant="success" class="ml-1" @click="geserJadwal"><i class="fa fa-cog"></i> Geser Jadwal</b-button>
                  <b-button v-if="(showFormGeser==false)" variant="primary" class="ml-1" @click="saveHalaman"><i class="fa fa-save"></i> Save Realisasi</b-button>
                  <b-button v-if="(frmdata.halamanb4)" variant="danger" class="ml-1" @click="delHalaman" > <i class="fa fa-undo"></i> Hapus Realisasi</b-button>
                  <b-button variant="secondary" class="ml-1" @click="cancelHalaman" > <i class="fa fa-close"></i>Cancel</b-button>
              </b-row>
      </b-modal>

  </div>
</template>

<style lang="scss">
  .list-of-opi {
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import opi from "../../apis/koran_iklanmuat";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuJenisiklan from "../lookup/lkuJenisIklanAll";
import lkuSalesae from "../lookup/lkuSalesae";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
// import ImgCutter from 'vue-img-cutter';
import ImgCutter from "../../components/ImgCutter";
toastr.init();

export default {
  components: {ImgCutter, Loading,lkuCustomer, lkuJenisiklan, lkuSalesae},
  mixins: [validationMixin],
  validations: {
        frmdata: {
            halaman: {required : (function() {
                if ((this.showFormGeser==true)) {
                    return true;
                } else if (!(this.frmdata.halaman)){
                    return false;
                } else return true;
            })},
            jadwalgeser: {required : (function() {
                if ((this.showFormGeser==false)) {
                    return true;
                } else if (!(this.frmdata.jadwalgeser)){
                    return false;
                } else return true;
            })},
            uraiangeser: {required : (function() {
                if ((this.showFormGeser==false)) {
                    return true;
                } else if (!(this.frmdata.uraiangeser)){
                    return false;
                } else return true;
            })},
        },
  }, 
  data() {
    return {
      lkuJenisIklanShow: false,
      lkuCustomerShow: false,
      lkuSalesShow: false,
      showForm:false,
      showFormGeser:true,      
      showFilter: false,
      showDelConfirm: false,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        status:"",istayang:'',
        postgroup:"",
        tgl1:'',tgl2:'', 
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      frmdata: { halaman:'', buktiiklan:'', imgURL:'', istayang:0, jadwalgeser:''},
      YesNoAll :   [{ value: '1', text: 'YES' }, { value: '0', text: 'NO' }, { value: '', text: '-ALL-' }],
      paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
      tblFields:[
          {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Date",
            sortable: true,
            thStyle: "width:90px",
            thClass: "text-center",
          },
          {
            key: "CustName",
            label: "Pemasang",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "juduliklan",
            label: "Judul Iklan",
          },
          {
            key: "jiklan",
            label: "Jenis Iklan",
            sortable: true
          },
          {
            key: "ukuraniklan",
            label: "Ukuran",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "posisirubrik",
            label: "Posisi/Rubrik",
            // thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "jadwalmuat",
            label: "Jadwal",
            thStyle: "width:100px",
            sortable: true,
          },
          {
            key: "halaman",
            label: "Halaman Muat",
            thStyle: "width:150px",
            thClass: "text-center",
            tdClass: "text-center",
            variant: "success",
          },
          {
            key: "SalesEx",
            label: "Sales Ex.",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "mediaorder",
            label: "Sales Order",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          }
      ],
    };
  },
  computed: {
    invalidFormdata (){
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },    
  },
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      if (tanggal) {
        const day_ = namesDay[moment(tanggal).day()];
        return day_;

      } else {
        return '';
      }
    }
  },  

  created: async function(){
        const now = new Date();
        const tgl1 = moment(now).startOf('month').format('YYYY-MM-DD');
        const tgl2 = moment(now).endOf('month').format('YYYY-MM-DD');
        this.tblData.tgl1=this.tblData.tgl1 || tgl1;
        this.tblData.tgl2=this.tblData.tgl2 || tgl2;
    const f = await opi.paymentForms() ;
      this.paymentForms = f.reduce((newArr,item) =>{
          newArr.push(item);
          return newArr;
      },[{ value: '', text: '--- ALL ---'}]);

  },  
  methods: {
    showGeserJadwal() {
      if (this.frmdata.orderlineid) {
        if ( this.frmdata.istayang==0) {
          this.showForm=true;
          this.showFormGeser=true;
        }
      }
    },
      cutDown: function (res) {
          // console.log('cutDown');
          // console.log(res);
          // this.downloadName = res.fileName;
          this.frmdata.buktiiklan= res.blob;
          this.frmdata.imgURL = res.dataURL;
          setTimeout(() => {
            this.$forceUpdate();
          }, 500);
      },
      onSelectLkuCustomer: async function (_selected) {
      this.tblData.pemasang = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.customer_name = _selected.CustName.trim();
      this.lkuCustomerShow=false;
    },    
    onSelectLkuJenisIklan: async function (_selected) {
      this.tblData.jiklanid = _selected.jiklanid;
      this.tblData.jiklan = _selected.jenisiklan;
      this.lkuJenisIklanShow=false;
    },    
    onSelectsales(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.lkuSalesShow = false;
    },

    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.realisasiiklancetak) {
            this.tblData[key] = filter.realisasiiklancetak[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.realisasiiklancetak.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.realisasiiklancetak;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await opi.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await opi.list(this.tblData);   

                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
        }

    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.juduliklan=  '';
        this.tblData.orderno=  '';
        this.tblData.platform=  '';
        this.tblData.customer_id=  '';
        this.tblData.pemasang=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.istayang='';
      this.tblData.salesae_id = "";
      this.tblData.salesae_name = "";

        this.refresh();
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','tglmuat', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', "salesae_name", 'baris','jiklan', 'jiklanid', 'posisirubrik','completed', 'jenisbayar'];
      let filtered = false;
      const realisasiiklancetak={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              realisasiiklancetak[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          realisasiiklancetak.page=this.tblData.page;
          realisasiiklancetak.limit=this.tblData.limit;
          realisasiiklancetak.sortBy=this.tblData.sortBy;
          realisasiiklancetak.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.realisasiiklancetak=realisasiiklancetak;
          this.$store.commit("filter", filter);
      }
    },    
    blobToBase64 : function(blob, callback) {
        var reader = new FileReader();
        reader.onload = function() {
            callback(reader.result);
        };
        reader.readAsDataURL(blob);
    },
    rowClicked(record, index) {
        if (this.showForm!=true) {
          this.showFormGeser=false;
          if ((this.frmdata) && (this.frmdata._rowVariant)) {
              delete this.frmdata._rowVariant;
          }
          this.frmdata = record;
          this.frmdata.halamanb4= record.halaman;
          this.frmdata.istayangb4= record.istayang;
          this.frmdata.imgURL='';
          if (this.frmdata.buktiiklan) {
               if (this.frmdata.buktiiklan instanceof Blob) {
                    this.blobToBase64(this.frmdata.buktiiklan, (res) =>{
                      this.frmdata.imgURL=res;
                    });
               } else {
                const buffer=Buffer.from(this.frmdata.buktiiklan,'binary');
                this.frmdata.imgURL = `data:image/png;base64,${buffer.toString('base64')}`;            
               }
          };
          record._rowVariant= 'info';
          this.$forceUpdate();
        }
    },
    cancelHalaman() {
          delete this.frmdata._rowVariant;
          this.frmdata.halaman=this.frmdata.halamanb4;
          this.frmdata.istayang=this.frmdata.istayangb4;      
          this.$forceUpdate();
        this.showForm=false;
    },    
    delHalaman: async function () {
        try {
          delete this.frmdata._rowVariant;
          this.frmdata.halaman='';
          this.frmdata.istayang= 0;
          // await opi.save(this.frmdata);
          const row = new FormData();
          row.append('orderlineid', this.frmdata.orderlineid);
          row.append('halaman', this.frmdata.halaman);
          row.append('istayang', (this.frmdata.halaman) ? 1: 0);
          await opi.save(row);
          this.frmdata.buktiiklan = '';
        } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
        }
        this.showForm=false;
    },    
    saveHalaman: async function () {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('model : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          } else {
            try {
              delete this.frmdata._rowVariant;
              this.frmdata.halaman=(this.frmdata.halaman || '').trim();
              this.frmdata.istayang= (this.frmdata.halaman) ? 1: 0;

              if (this.frmdata.istayang==0) this.frmdata.halaman='';
              // await opi.save(this.frmdata);

              const row = new FormData();
              row.append('orderlineid', this.frmdata.orderlineid);
              row.append('halaman', this.frmdata.halaman);
              row.append('istayang', (this.frmdata.halaman) ? 1: 0);
              if (this.frmdata.buktiiklan){
                  row.append('file', this.frmdata.buktiiklan);
              }
              await opi.save(row);

              this.showForm=false;
            } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
        }
    },    
    geserJadwal: async function () {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('model : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          } else {
            try {
              const tgl1=moment(this.frmdata.jadwalmuat).format('YYYY-MM-DD');
              const tgl2=moment(this.frmdata.jadwalgeser).format('YYYY-MM-DD');
              if (tgl1 != tgl2){
                await opi.geser({
                  orderlineid: this.frmdata.orderlineid,
                  jadwalgeser:tgl2, 
                  uraiangeser: this.frmdata.uraiangeser,
                  orderlineid: this.frmdata.orderlineid,
                  orderid: this.frmdata.orderid,
                  jadwalmuat: tgl1
                  } );
                this.frmdata.jadwalmuat=tgl2;
              }
              this.showForm=false;
            } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
        }
    },    

    exportxls: async function() {
        this.isLoading=true;
        try {
            await opi.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        // router.push({name:'opiment.home'});
          router.push({name: "iklankoran.home"});
    }

  }
};
</script>
